import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { passengerHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: string;
  name: string;
  section_english:string;
  help_section_name_malay: string;
  help_section_name_mandarin: string;
  help_redirect_link_english: string;
  sequence:string;
  published:boolean;
}

// edit api call
const fetchHelpContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${passengerHost}/api/get-help-card-crud-api-data/${id}`);
  console.log(response.data.data, 'testtttt')
  return response?.data.data;
};

const useHelpContentDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["HelpContentDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchHelpContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useHelpContentDocumentDetails };

